export const GESTIFY_TOKEN = 'gestifyToken';
export const GESTIFY_REFRESH_TOKEN = 'gestifyRefreshToken';
export const ERROR_TOKEN = 'errorToken';
export const USERNAME = 'username';
export const PASSWORD = 'password';
